import {
  LinearSeriesSettings,
  SeriesSettings,
  ValueAxisType,
} from "../../../../../api/biClient.types.ts";

export function getValueAxisType(serie: SeriesSettings | undefined): ValueAxisType {
  const linearSerie = serie as LinearSeriesSettings;
  return linearSerie?.valueAxis || "Main";
}
